// extracted by mini-css-extract-plugin
export default {"unassigned":"u3QWM","right":"nmtb9","tag":"ZjoG_","shortDesc":"j5dB8","commentIcon":"cvWzM"};